import React from 'react';

import { VoucherFormValidSince } from './ValidSince';
import { VoucherFormValidUntil } from './ValidUntil';

const VoucherFormValidityInterval: React.FC<{ disabled: boolean; busPartnerValidity: boolean }> = ({
  disabled,
  busPartnerValidity,
}) => {
  return (
    <>
      <VoucherFormValidSince disabled={disabled} busPartner={busPartnerValidity} />
      <VoucherFormValidUntil disabled={disabled} busPartner={busPartnerValidity} />
    </>
  );
};

export default VoucherFormValidityInterval;
